<template>
  <div class="bg-white">
    <CoverPage />
    <!-- <LatestNews :selected="path" /> -->

    <RecentPodcast />
    <Categoriesplay />
    <!-- <div class="md:w-4/5 lg:w-4/5 w-full md:px-0 lg:px-0 px-4 mx-auto">
      <div class="border my-6 rounded-lg p-3 lg:mb-12 md:mb-12">
        <h3 class="fsize22 font-semibold">Disclaimer:</h3>
        <p class="leading-tight fsize16 mt-3 clr-2e2e2e">
          The information provided on this website is for educational purposes
          only and is not intended to be a substitute for professional medical
          advice, diagnosis, or treatment.
        </p>
        <p class="fsize16 mt-2 clr-2e2e2e">
          Readers should seek professional medical advice and treatment for any
          specific health-related issues."
        </p>
        <p class="fsize16 mt-2 clr-2e2e2e">
          The information presented on this website is provided 'as is' without
          any representations or warranties, express or implied. The website
          owner and contributors disclaim all liability for any damages or
          losses arising from the use of this information.
        </p>
      </div>
    </div> -->
    <div class="bge3ceff-opa rounded-t-5555 mt-12 relative zindex1">
      <div class="absolute -top-56 right-8 md:block lg:block hidden">
        <img
          src="./../../../assets/images/bg-des/footer-bg.svg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <DownloadApp />
      <Footer />
    </div>
    <!-- <div
      v-if="selectedList"
      class="fixed bottom-0 left-0 w-full h-[140px] z-50 flex justify-center items-center px-4"
    >
      <div
        class="w-full max-w-4xl h-full bg-white rounded-lg overflow-hidden shadow-large flex items-center relative"
      >
        <button
          @click="closePlayer()"
          class="bg-gray-300 px-2 py-1 rounded-full hover:bg-red-400 text-black hover:text-white transition-colors absolute top-3 right-4 z-10"
          aria-label="Close Player"
        >
          ✕
        </button>
        <iframe
          style="border-radius: 12px"
          :src="embedLink"
          class="w-full h-full p-1"
          scrolling="no"
          frameborder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
      </div>
    </div> -->
  </div>
</template>
<script>
import CoverPage from "./components/CoverPage.vue";
import DownloadApp from "../../home/components/DownloadApp.vue";
import Categoriesplay from "./components/Categoriesplay.vue";
import RecentPodcast from "./components/RecentPodcast.vue";
import LatestNews from "./components/LatestNews.vue";
import Footer from "../../Footer.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      path: "",
    };
  },
  components: {
    CoverPage,
    DownloadApp,
    Categoriesplay,
    RecentPodcast,
    Footer,
    LatestNews,
  },
  metaInfo: {
    title: "Our Podcast | Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Listen to the inspirining caregiving stories of people. Caregiver Saathi presents - Caregiver Diaries and Untold Stories of Gentle Warriors",
      },
    ],
  },
  // methods: {
  //   async closePlayer(item = null) {
  //     await this.$store.commit("cms/SET_SELECTED_LIST", item);
  //   },
  // },
  async mounted() {
    this.path =
      this.$router.currentRoute.fullPath.split("/")[1] == "Corporate"
        ? this.$router.currentRoute.fullPath.split("/")[1]
        : "";
    console.log(this.path, "PATH");
    // await this.closePlayer(null); //initially close the player
  },
  computed: {
    ...mapState("cms", { selectedList: "selectedList" }),
    embedLink() {
      if (this.selectedList && this.selectedList.link) {
        if (this.selectedList.link.includes("embed")) {
          return this.selectedList.link;
        }
        return this.selectedList.link.replace(
          "/pod/show/caregiver-saathi/",
          "/pod/show/caregiver-saathi/embed/"
        );
      }
      return "";
    },
  },
};
</script>
<style>
.shadow-large {
  box-shadow: 1px -2px 20px 7px rgba(0, 0, 0, 0.2);
}
</style>
